import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { useRequestFromPage } from '@Hooks/index';

import logoDark from '@Images/logo-dark.png';

import styles from './full-width-layout.module.css';

const { Content } = Layout;

interface FullWidthLayoutProps {
  children: JSX.Element | JSX.Element[];
}

const ContactPageLogo: React.FC = () => {
  return (
    <div className={styles.logo}>
      <img
        className={styles.image}
        src={logoDark}
        alt="Trojan construction company logotype"
      />
    </div>
  );
};

const FullWidthLayout: React.FC<FullWidthLayoutProps> = ({ children }) => {
  const isRequestFormPage = useRequestFromPage();

  return (
    <Layout>
      {React.cloneElement(children as JSX.Element, {
        logoComponent: <ContactPageLogo />,
      })}
      <Content className={styles.wrapper}>
        <Outlet context={{ isRequestFormPage }} />
      </Content>
    </Layout>
  );
};

export default FullWidthLayout;
